'use client';

import { useEffect, useState } from 'react';

import { UTMParams, initializeUTMParams } from '@/shared/utils/utmParams';

export const useSavedUtmParams = () => {
  const [utmParams, setUtmParams] = useState<UTMParams>({});

  useEffect(() => {
    setUtmParams(initializeUTMParams());
  }, []);

  return utmParams;
};
